import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImageSliderService {

  public setSlideIndex: Subject<number> = new Subject<number>();

  /**
   * Constructor
   */
  public constructor() { }
}
